
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
.container {

    margin-top: 1.5rem;

    margin-bottom: 1.5rem;

    border-radius: 1rem;

    background-color: var(--cyan-near-lighten-4);

    padding: 2rem
}

@media (min-width: 768px) {

    .container {

        margin-top: 0px;

        margin-bottom: 0px
    }
}

.container-content-wrapper {

    display: flex;

    flex-direction: column;

    flex-wrap: wrap;

    gap: 1rem
}

.content, .legends {

    display: flex;

    width: 100%;

    flex-wrap: wrap;

    justify-content: center
}

.cta {

    margin-left: -1rem
}

.content {

    gap: 1rem
}

@media (min-width: 768px) {

    .content {

        min-height: 28rem
    }
}
`;